var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-18 col-sm-16 col-sm-offset-1"},[_c('figure',[_vm._t("default"),_vm._v(" "),(_vm.caption)?_c('figcaption',{domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e()],2)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f00e6e8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageFull.vue
// module id = null
// module chunks = 